import SDIcon from "@/common/images/icons/sd.svg?react";
import HDIcon from "@/common/images/icons/hd.svg?react";
import { clsx } from "clsx";
import "./QualityButton.scss";

enum QualityType {
  SD = "sd",
  HD = "hd",
}

interface IQualityButtonProps {
  quality: string;
  onChange: (quality: string) => void;
}

export const QualityButton: React.FC<IQualityButtonProps> = ({
  quality,
  onChange
}) => {
  const isSDQuality = quality === QualityType.SD;

  return (
    <button
      onClick={() => onChange(isSDQuality ? QualityType.HD : QualityType.SD)}
      className={clsx("QualityButton", isSDQuality ? QualityType.SD : QualityType.HD)}
      aria-label="toggle gif quality"
    >
      {isSDQuality ? <SDIcon /> : <HDIcon />}
    </button>
  );
};
